webpackJsonp([273337162235335],{

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  color: var(--link-color);\n  text-decoration: none;\n  border-bottom: 2px solid transparent;\n  transition: all 0.1s ease;\n  display: inline-flex;\n  padding-bottom: 0.1em;\n  &:hover,\n  &:focus {\n    border-bottom: 2px solid var(--link-color);\n  }\n"], ["\n  color: var(--link-color);\n  text-decoration: none;\n  border-bottom: 2px solid transparent;\n  transition: all 0.1s ease;\n  display: inline-flex;\n  padding-bottom: 0.1em;\n  &:hover,\n  &:focus {\n    border-bottom: 2px solid var(--link-color);\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  margin-right: 0.2em;\n"], ["\n  margin-right: 0.2em;\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n"]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  flex: 1 1 20em;\n  max-width: 30em;\n  margin-left: 1em;\n"], ["\n  flex: 1 1 20em;\n  max-width: 30em;\n  margin-left: 1em;\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n  margin: 0;\n"], ["\n  margin: 0;\n"]),
	    _templateObject6 = _taggedTemplateLiteralLoose(["\n  font-size: 0.8em;\n  margin: 0;\n"], ["\n  font-size: 0.8em;\n  margin: 0;\n"]),
	    _templateObject7 = _taggedTemplateLiteralLoose([""], [""]),
	    _templateObject8 = _taggedTemplateLiteralLoose(["\n  flex: 1 1 10em;\n  max-width: 100%;\n  @media (min-width: 600px) {\n    max-width: 25em;\n  }\n"], ["\n  flex: 1 1 10em;\n  max-width: 100%;\n  @media (min-width: 600px) {\n    max-width: 25em;\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(10);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Arrow = function Arrow() {
	  return _react2.default.createElement(
	    "svg",
	    {
	      fill: "currentColor",
	      height: "24",
	      viewBox: "0 0 24 24",
	      width: "24",
	      xmlns: "http://www.w3.org/2000/svg"
	    },
	    _react2.default.createElement("path", { d: "M22 12l-4-4v3H3v2h15v3z" }),
	    _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
	  );
	};
	
	var Project = function Project(_ref) {
	  var pathContext = _ref.pathContext;
	  var title = pathContext.title,
	      subtitle = pathContext.subtitle,
	      description = pathContext.description,
	      image = pathContext.image,
	      _pathContext$website = pathContext.website,
	      website = _pathContext$website === undefined ? null : _pathContext$website;
	
	
	  return _react2.default.createElement(
	    StyledProject,
	    null,
	    _react2.default.createElement(StyledImage, { src: "/" + image + ".svg", alt: "" }),
	    _react2.default.createElement(
	      Contents,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        title
	      ),
	      _react2.default.createElement(
	        Subtitle,
	        null,
	        subtitle
	      ),
	      _react2.default.createElement(
	        Description,
	        null,
	        description
	      ),
	      website === null ? null : _react2.default.createElement(
	        ExternalLink,
	        { href: website },
	        _react2.default.createElement(
	          Span,
	          null,
	          "visit website"
	        ),
	        " ",
	        _react2.default.createElement(Arrow, null)
	      )
	    )
	  );
	};
	
	var ExternalLink = _styledComponents2.default.a(_templateObject);
	
	var Span = _styledComponents2.default.span(_templateObject2);
	
	var StyledProject = _styledComponents2.default.div(_templateObject3);
	
	var Contents = _styledComponents2.default.div(_templateObject4);
	
	var Title = _styledComponents2.default.h1(_templateObject5);
	
	var Subtitle = _styledComponents2.default.p(_templateObject6);
	
	var Description = _styledComponents2.default.p(_templateObject7);
	
	var StyledImage = _styledComponents2.default.img(_templateObject8);
	
	exports.default = Project;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-components-project-index-js-d0e1ce4d71e503a2dd44.js